
import Utils from './global.utils'

export default class Global extends Utils{}


